import { FinalChartData } from '@/types/salesChart';
import { toDe } from '@/utilites/sku-operations';
import translationFallback from '@/utilites/translations/translationFallback';

const SalesChartTooltip = ({
  active,
  payload,
  label,
}: {
  active: boolean;
  payload: { value: number | number[]; payload: FinalChartData }[];
  label: string;
}) => {
  const getTooltipSales = (value: number[] | number) => {
    const isArray = Array.isArray(value);
    let valuesString = '';
    if (isArray) {
      valuesString = value.map((v) => toDe(v)).join(' | ');
      return valuesString;
    }
    return toDe(value);
  };
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip bg-white rounded border px-5 py-3 shadow">
        <p className="label mb-0">{`${translationFallback(
          'value.date',
          'value.date',
          'Date'
        )}: ${label}`}</p>
        <p className="label mb-0">{`${translationFallback(
          'value.market_value',
          'value.market_value',
          'Market value'
        )}: ${typeof payload[0]?.value === 'number' ? toDe(payload[0]?.value) : ''}`}</p>
        {payload.length > 1 ? (
          <p className="label mb-0">{`Sales: ${
            typeof payload[1]?.payload?.sales === 'number' ||
            Array.isArray(payload[1]?.payload?.sales)
              ? getTooltipSales(payload[1]?.payload?.sales)
              : ''
          }`}</p>
        ) : (
          ''
        )}
      </div>
    );
  }

  return null;
};

export default SalesChartTooltip;
